import Payment from './Payment'
import utils from "../../shared/Utils"

export default class Confirmation {
  constructor(component) {
    this.component = component
  }
  name() {
    return 'confirmation'
  }
  handle(event) {
    if(event.back) {
      this.component.modalExpanded = false
      this.component.transaction_controller = new Payment(this.component)
      return
    }
    if(event.createTransactionAttributes) {
      let successCallback = (response) => {
        if (response.body.data) {
          this.component.onClose()
          this.component.$root.$emit('reload-transactions', response.body.data)
        }
      }
      let errorCallback = (response) => {
        if (response.status === 401) {
          this.component.$router.push('/sign_in')
        } else {
          console.log('errorCallback', response)
          this.component.$root.$emit('error-feedback', response.body.errors)
        }
      }

      let token = this.component.$cookies.get('api_token')
      let payload = event.createTransactionAttributes

      if (payload.transaction.reverse_exchange) {
        delete payload.transaction.value;
      } else {
        delete payload.transaction.exchanged_value;
      }

      delete payload.transaction.reverse_exchange
      this.component.$http.post(this.component.$root.urls.customer__scheduled_bank_transactions, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      return
    }
  }
}




// WEBPACK FOOTER //
// ./src/controllers/NewTransaction/Confirmation.js